import { render, staticRenderFns } from "./AddTaskPanel.vue?vue&type=template&id=458623e1&scoped=true"
import script from "./AddTaskPanel.vue?vue&type=script&lang=js"
export * from "./AddTaskPanel.vue?vue&type=script&lang=js"
import style0 from "./AddTaskPanel.vue?vue&type=style&index=0&id=458623e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458623e1",
  null
  
)

export default component.exports